import React from "react";
import ParameterModal from './ParameterModal';

const Search = props => {
  return (<div>
    {props.showParams && <ParameterModal showParams={props.showParams} showModal={props.showModal} parameters={props.parameters} handleParamChange={props.handleParamChange}/>}
    <form action="">
        <label htmlFor="song" className="visuallyhidden">
          Enter a song
        </label>
        <input type="text" id="song" value={props.searchTerm} onChange={props.songAutofill} placeholder="Enter your favourite song" autoComplete="off" className="songInput"/>

        {(props.autofillSongs.length > 0 && props.showAutofill) && <ul>
            {props.autofillSongs.map(song => {
              return <li id={song.songId} key={song.songId} onClick={props.updateSearch}>
                  {song.songName} by {song.artistNames.map(name => name + "  ")} {song.albumName} ({song.albumYear})
                </li>;
            })}
          </ul>}

        <div>
          <label htmlFor="showGenres" className="visuallyhidden">
            Select a genre
          </label>
          <input type="text" id="showGenres" value={props.selectedGenre} readOnly onClick={props.handleToggleClick} placeholder="Select a genre" />

          {/* Show genre select based on whether condition is true or false */}
          {props.showGenres && <ul>
              {props.genres.map(genre => {
                return <li id={genre.code} key={genre.code} onClick={props.updateGenre}>
                    {genre.name}
                  </li>;
              })}
            </ul>}
          
        <button onClick={props.showModal} id="showParams" className="advancedOptions">Advanced options</button>
        </div>

        <div className="actionButtons">
          <button onClick={props.handleRecommendation} id="recommendButton">Recommend</button>

          <button onClick={props.randomizeSelection} className="randomizeButton">Randomize</button>

        </div>
      </form>
    </div>);
};

export default Search;
